// import { useState, useEffect } from "react";
// import MainLayouts from "../../Layout/MainLayouts";
// import { ReactComponent as PencilFill } from "bootstrap-icons/icons/pencil-fill.svg";
// import { ReactComponent as ArrowLeftCircleLeftFill } from "bootstrap-icons/icons/arrow-left-circle-fill.svg";
// import { ReactComponent as ArrowRightCircleLeftFill } from "bootstrap-icons/icons/arrow-right-circle-fill.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
// import Spinner from "../spinner/Spinner";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiServices from "../../api/ApiServices";
// import { toast } from "react-toastify";
// import { handleError } from "../../components/utils/AuthenticationCheck";
// import AxiosApiCall from "../../api/AxiosApiCall";

// const AssignPermissionToAdmin = () => {
//   const [permissions, setPermissions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [permissionsPerPage] = useState(12);
//   const [filterText, setFilterText] = useState("");
//   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//   const [selectedPermissions, setSelectedPermissions] = useState([]);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const admin = location.state?.admin;

//   const [admin_id] = useState(admin?.admin_id || "");
//   const [adminName] = useState(admin?.fullname || "");
//   const [adminEmail] = useState(admin?.email || "");

//   useEffect(() => {
//     const fetchAllPermissionList = async () => {
//       setLoading(true);
//       try {
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) {
//           throw new Error("No access token found.");
//         }
//         const response = await axios.get(ApiServices.getPermissions, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         });

//         const { status, message, data } = response.data;
//         if (status === 200) {
//           setPermissions(data);
//           // toast.success(message, { toastId: "permission-fetch-success" });
//         } else {
//           handleError({ response: { status, data: { message } } }, navigate);
//         }
//       } catch (error) {
//         handleError(error, navigate);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllPermissionList();
//   }, []);

//   const validateForm = () => {
//     if (selectedPermissions.length === 0 || !admin_id) {
//       toast.error("Please select at least one permission.");
//       return false;
//     }
//     return true;
//   };


//   //axios api encryption call
//   const axios = AxiosApiCall();

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     setLoading(true);
//     const formData = {
//       permission_ids: selectedPermissions,
//       admin_id: admin_id,
//     };
//     // console.log(formData);
//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) {
//         throw new Error("No access token found.");
//       }

//       const response = await axios.post(
//         ApiServices.assignPermissions,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         }
//       );

//       const { status, message } = response.data;
//       if (status === 200) {
//         navigate("/admin/view/list");
//         toast.success(message, { toastId: "Permission-updated-successfully" });
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//     setResetPaginationToggle(!resetPaginationToggle);
//   };

//   // Function to format permission text
//   const formatPermissionText = (text) => {
//     // Replace underscores with spaces
//     let formattedText = text.replace(/_/g, " ");

//     // Capitalize the first letter of each word
//     formattedText = formattedText
//       .toLowerCase()
//       .replace(/\b\w/g, (char) => char.toUpperCase());

//     return formattedText;
//   };

//   const filteredPermissions = permissions.filter((item) =>
//     item.name.toLowerCase().includes(filterText.toLowerCase().trim())
//   );

//   const indexOfLastPermission = currentPage * permissionsPerPage;
//   const indexOfFirstPermission = indexOfLastPermission - permissionsPerPage;
//   const currentPermissions = filteredPermissions.slice(
//     indexOfFirstPermission,
//     indexOfLastPermission
//   );

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const hasNextPage = () => indexOfLastPermission < filteredPermissions.length;
//   const hasPrevPage = () => currentPage > 1;

//   const parsePermission = (permission) => {
//     const [resource, action] = permission.split(".");
//     return { resource, action };
//   };

//   const handleCheckboxChange = (permissionId) => {
//     setSelectedPermissions((prevSelected) =>
//       prevSelected.includes(permissionId)
//         ? prevSelected.filter((id) => id !== permissionId)
//         : [...prevSelected, permissionId]
//     );
//   };

//   return (
//     <div>
//       <MainLayouts>
//         <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//           <section
//             className="w-full pl-[3%] pr-[3%] pt-3 my-3"
//             style={{ backgroundColor: "#F7F7F7" }}
//           >
//             <nav className="bg-gray-200 py-0 px-1 rounded-lg ">
//               <ol className="list-none p-0 inline-flex mb-2">
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pl-1">
//                     Assign Permission To
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 {adminName && (
//                   <li className="flex items-center">
//                     <p className="text-gray-600 text-black1">
//                       <span className="font-medium pl-1">{adminName}</span>
//                     </p>
//                     <ChevronRightIcon />
//                   </li>
//                 )}
//                 {adminEmail && (
//                   <li className="flex items-center">
//                     <p className="text-gray-600 text-orange1">
//                       <span className="font-medium pl-1">{adminEmail}</span>
//                     </p>
//                   </li>
//                 )}
//               </ol>
//             </nav>
//           </section>
//           <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap items-center justify-between gap-4">
//             <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
//               <input
//                 type="search"
//                 className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
//                 placeholder="Search"
//                 value={filterText}
//                 onChange={handleFilter}
//               />
//             </div>
//           </div>
//           {loading ? (
//             <Spinner loading={loading} />
//           ) : (
//             <form onSubmit={handleSubmit}>
//               <section className="text-gray-600 body-font">
//                 <div className="container px-1 py-2 mx-auto">
//                   <div className="flex flex-wrap -m-2">
//                     {currentPermissions.length > 0 ? (
//                       currentPermissions.map((permission, index) => {
//                         const { resource, action } = parsePermission(
//                           permission.name
//                         );
//                         return (
//                           <div
//                             key={index}
//                             className="p-2 lg:w-1/3 md:w-1/2 w-full"
//                           >
//                             <div className="h-full flex items-center border-darkGreen3 border p-4 rounded-lg">
//                               <div className="flex-grow">
//                                 <h2 className="flex items-center justify-between text-darkGreen3 title-font font-medium">
//                                   <span>{action}</span>

//                                   <input
//                                     type="checkbox"
//                                     className="ml-4"
//                                     checked={selectedPermissions.includes(
//                                       permission.permission_id
//                                     )}
//                                     onChange={() =>
//                                       handleCheckboxChange(
//                                         permission.permission_id
//                                       )
//                                     }
//                                   />
//                                 </h2>

//                                 <p className="text-gray-500 flex items-center">
//                                   Permission for:{" "}
//                                   <span className="ml-2 text-dash5">
//                                     {formatPermissionText(resource)}
//                                   </span>
//                                 </p>
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })
//                     ) : (
//                       <div className="w-full text-center">
//                         No permissions found
//                       </div>
//                     )}
//                   </div>

//                   <div className="flex flex-col gap-3 sm:flex-row justify-between mt-4">
//                     <div className="flex items-center gap-3">
//                       <button
//                         type="button"
//                         disabled={!hasPrevPage()}
//                         onClick={() => paginate(currentPage - 1)}
//                         className={`text-dGrey3 bg-black2  hover:bg-darkGreen2 focus:outline-none font-medium rounded-full text-sm px-5 py-2 text-center inline-flex items-center gap-1 ${!hasPrevPage() && "opacity-50"
//                           }`}
//                       >
//                         <ArrowLeftCircleLeftFill />
//                         Previous
//                       </button>
//                       <button
//                         type="button"
//                         disabled={!hasNextPage()}
//                         onClick={() => paginate(currentPage + 1)}
//                         className={`text-dGrey3 bg-black2  hover:bg-darkGreen2 focus:outline-none font-medium rounded-full text-sm px-5 py-2 text-center inline-flex items-center gap-1 ${!hasNextPage() && "opacity-50"
//                           }`}
//                       >
//                         Next
//                         <ArrowRightCircleLeftFill />
//                       </button>

//                     </div>
//                     <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
//                       <Link
//                         to="/admin/view/list"
//                         className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center"
//                       >
//                         <List className="mr-2" />
//                         Back To List
//                       </Link>
//                       <button
//                         type="submit"
//                         className={`text-white bg-darkGreen3 text-dGrey3 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"
//                           }`}
//                         disabled={loading}
//                       >
//                         {loading
//                           ? "Loading..."
//                           : "   Assign Selected Permissions"}
//                       </button>
//                     </div>


//                   </div>
//                 </div>
//               </section>
//             </form>
//           )}
//         </div>
//       </MainLayouts>
//     </div>
//   );
// };

// export default AssignPermissionToAdmin;

import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as PencilFill } from "bootstrap-icons/icons/pencil-fill.svg";
import { ReactComponent as ArrowLeftCircleLeftFill } from "bootstrap-icons/icons/arrow-left-circle-fill.svg";
import { ReactComponent as ArrowRightCircleLeftFill } from "bootstrap-icons/icons/arrow-right-circle-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import Spinner from "../spinner/Spinner";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { handleError } from "../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../api/AxiosApiCall";

const AssignPermissionToAdmin = () => {
  // State for pagination and filtering
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [permissionsPerPage] = useState(12);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  // State for permissions data
  const [allPermissions, setAllPermissions] = useState([]);
  const [adminPermissions, setAdminPermissions] = useState([]);
  const [availablePermissions, setAvailablePermissions] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const admin = location.state?.admin;

  const [admin_id] = useState(admin?.admin_id || "");
  const [adminName] = useState(admin?.fullname || "");
  const [adminEmail] = useState(admin?.email || "");

  // Enhanced axios instance
  const axiosInstance = AxiosApiCall();

  // Helper function to get auth token
  const getAuthToken = () => {
    const authData = JSON.parse(localStorage.getItem("auth"));
    const token = authData?.token;
    if (!token) throw new Error("No access token found.");
    return token;
  };

  // Fetch admin's existing permissions
  const fetchAdminPermissions = async () => {
    try {
      const token = getAuthToken();
      const response = await axiosInstance.get(ApiServices.getAdminPermissionsByid, {
        headers: { Authorization: `Bearer ${token}` },
        params: { admin_id: admin.admin_id },
        withCredentials: true,
      });

      if (response.data.status === 200) {
        const permissionIds = response.data.data.map(p => p.permission_id);
        setAdminPermissions(permissionIds);
        // console.log("Admin existing permissions:", permissionIds);
        return permissionIds;
      } else {
        throw new Error(response.data.message || "Failed to fetch admin permissions");
      }
    } catch (error) {
      // console.error("Error fetching admin permissions:", error);
      handleError(error, navigate);
      return [];
    }
  };

  // Fetch all available permissions
  const fetchAllPermissions = async () => {
    try {
      const token = getAuthToken();
      const response = await axiosInstance.get(ApiServices.getPermissions, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      if (response.data.status === 200) {
        setAllPermissions(response.data.data);
        // console.log("All permissions:", response.data.data);
        return response.data.data;
      } else {
        throw new Error(response.data.message || "Failed to fetch all permissions");
      }
    } catch (error) {
      // console.error("Error fetching all permissions:", error);
      handleError(error, navigate);
      return [];
    }
  };

  // Load data when component mounts
  useEffect(() => {
    const loadPermissionsData = async () => {
      if (!admin?.admin_id) {
        toast.error("Admin information is missing");
        navigate("/admin/view/list");
        return;
      }

      setLoading(true);
      try {
        // Fetch both admin permissions and all permissions concurrently
        const [adminPerms, allPerms] = await Promise.all([
          fetchAdminPermissions(),
          fetchAllPermissions()
        ]);

        // Filter permissions that admin doesn't have
        const available = allPerms.filter(
          permission => !adminPerms.includes(permission.permission_id)
        );

        setAvailablePermissions(available);
        // console.log("Available permissions (filtered):", available);

        setDataLoaded(true);
      } catch (error) {
        // console.error("Error loading permissions data:", error);
        toast.error("Failed to load permissions data");
      } finally {
        setLoading(false);
      }
    };

    loadPermissionsData();
  }, [admin?.admin_id, navigate]);

  // Alternative effect-based approach (if you prefer the original structure)
  useEffect(() => {
    if (allPermissions.length > 0 && adminPermissions.length >= 0) {
      const filtered = allPermissions.filter(
        permission => !adminPermissions.includes(permission.permission_id)
      );
      setAvailablePermissions(filtered);
      // console.log("Filtering permissions:", {
      //   total: allPermissions.length,
      //   adminHas: adminPermissions.length,
      //   available: filtered.length
      // });
    }
  }, [allPermissions, adminPermissions]);

  const validateForm = () => {
    if (selectedPermissions.length === 0) {
      toast.error("Please select at least one permission.");
      return false;
    }
    if (!admin_id) {
      toast.error("Admin ID is missing.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    const formData = {
      permission_ids: selectedPermissions,
      admin_id: admin_id,
    };

    // console.log("Submitting form data:", formData);

    try {
      const token = getAuthToken();
      const response = await axiosInstance.post(
        ApiServices.assignPermissions,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "Permission-updated-successfully" });
        navigate("/admin/view/list");
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      // console.error("Error assigning permissions:", error);
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setCurrentPage(1); // Reset to first page when filtering
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Function to format permission text
  const formatPermissionText = (text) => {
    return text
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // Filter permissions based on search text
  const filteredPermissions = availablePermissions.filter((item) =>
    item.name.toLowerCase().includes(filterText.toLowerCase().trim())
  );

  // Pagination calculations
  const indexOfLastPermission = currentPage * permissionsPerPage;
  const indexOfFirstPermission = indexOfLastPermission - permissionsPerPage;
  const currentPermissions = filteredPermissions.slice(
    indexOfFirstPermission,
    indexOfLastPermission
  );

  const totalPages = Math.ceil(filteredPermissions.length / permissionsPerPage);
  const hasNextPage = () => currentPage < totalPages;
  const hasPrevPage = () => currentPage > 1;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const parsePermission = (permission) => {
    const [resource, action] = permission.split(".");
    return { resource: resource || permission, action: action || "manage" };
  };

  const handleCheckboxChange = (permissionId) => {
    setSelectedPermissions((prevSelected) =>
      prevSelected.includes(permissionId)
        ? prevSelected.filter((id) => id !== permissionId)
        : [...prevSelected, permissionId]
    );
  };

  // Early return if admin data is missing
  if (!admin) {
    return (
      <MainLayouts>
        <div className="flex justify-center items-center h-64">
          <p className="text-red-500">Admin information is missing. Please go back and select an admin.</p>
        </div>
      </MainLayouts>
    );
  }

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          {/* Breadcrumb Section */}
          <section
            className="w-full pl-[3%] pr-[3%] pt-3 my-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <nav className="bg-gray-200 py-0 px-1 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pl-1">
                    Assign Permission
                  </p>
                  <ChevronRightIcon />
                </li>
                {/* {adminName && (
                  <li className="flex items-center">
                    <p className="text-gray-600 text-black1">
                      <span className="font-medium pl-1">{adminName}</span>
                    </p>
                    <ChevronRightIcon />
                  </li>
                )} */}
                {adminEmail && (
                  <li className="flex items-center">
                    <p className="text-gray-600 text-orange1">
                      <span className="font-medium pl-1">{adminEmail}</span>
                    </p>
                  </li>
                )}
              </ol>
            </nav>
          </section>

          {/* Search and Info Section */}
          <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap items-center justify-between gap-4">
            <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
              <input
                type="search"
                className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                placeholder="Search available permissions..."
                value={filterText}
                onChange={handleFilter}
              />
            </div>
            <div className="text-sm text-gray-600">
              {/* <span className="font-medium">{filteredPermissions.length}</span> permissions available to assign */}
              {selectedPermissions.length > 0 && (
                <span className="ml-4 text-green-600">
                  ({selectedPermissions.length} selected)
                </span>
              )}
            </div>
          </div>

          {/* Loading or Content */}
          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <form onSubmit={handleSubmit}>
              <section className="text-gray-600 body-font">
                <div className="container px-1 py-2 mx-auto">
                  <div className="flex flex-wrap -m-2">
                    {currentPermissions.length > 0 ? (
                      currentPermissions.map((permission, index) => {
                        const { resource, action } = parsePermission(permission.name);
                        return (
                          <div
                            key={permission.permission_id}
                            className="p-2 lg:w-1/3 md:w-1/2 w-full"
                          >
                            <div className="h-full flex items-center border-darkGreen3 border p-4 rounded-lg hover:shadow-md transition-shadow">
                              <div className="flex-grow">
                                <h2 className="flex items-center justify-between text-darkGreen3 title-font font-medium">
                                  <span className="capitalize">{formatPermissionText(action)}</span>
                                  <input
                                    type="checkbox"
                                    className="ml-4 h-4 w-4"
                                    checked={selectedPermissions.includes(permission.permission_id)}
                                    onChange={() => handleCheckboxChange(permission.permission_id)}
                                  />
                                </h2>
                                <p className="text-gray-500 flex items-center">
                                  Permission for:{" "}
                                  <span className="ml-2 text-dash5 capitalize">
                                    {formatPermissionText(resource)}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="w-full text-center py-8">
                        {filterText ? (
                          <p className="text-gray-500">
                            No permissions found matching "{filterText}"
                          </p>
                        ) : (
                          <p className="text-gray-500">
                            This admin already has all available permissions
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Pagination and Actions */}
                  <div className="flex flex-col gap-3 sm:flex-row justify-between mt-6">
                    {/* Pagination */}
                    <div className="flex items-center gap-3">
                      <button
                        type="button"
                        disabled={!hasPrevPage()}
                        onClick={() => paginate(currentPage - 1)}
                        className={`text-dGrey3 bg-black2 hover:bg-darkGreen2 focus:outline-none font-medium rounded-full text-sm px-5 py-2 text-center inline-flex items-center gap-1 transition-colors ${!hasPrevPage() && "opacity-50 cursor-not-allowed"
                          }`}
                      >
                        <ArrowLeftCircleLeftFill />
                        Previous
                      </button>

                      {/* <span className="text-sm text-gray-600">
                        Page {currentPage} of {totalPages}
                      </span> */}

                      <button
                        type="button"
                        disabled={!hasNextPage()}
                        onClick={() => paginate(currentPage + 1)}
                        className={`text-dGrey3 bg-black2 hover:bg-darkGreen2 focus:outline-none font-medium rounded-full text-sm px-5 py-2 text-center inline-flex items-center gap-1 transition-colors ${!hasNextPage() && "opacity-50 cursor-not-allowed"
                          }`}
                      >
                        Next
                        <ArrowRightCircleLeftFill />
                      </button>
                    </div>

                    {/* Action Buttons */}
                    <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                      <Link
                        to="/admin/view/list"
                        className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center transition-colors"
                      >
                        <List className="mr-2" />
                        Back To List
                      </Link>
                      <button
                        type="submit"
                        className={`text-white bg-darkGreen3 text-dGrey3 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium transition-colors ${loading || selectedPermissions.length === 0
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                          }`}
                        disabled={loading || selectedPermissions.length === 0}
                      >
                        {loading
                          ? "Assigning..."
                          : `Assign Selected Permissions (${selectedPermissions.length})`}
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </form>
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default AssignPermissionToAdmin;